//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { api_GetGiftList, api_ReceiveGift, api_ReceiveGiftCDK } from "@/api";
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      tabs: 0,
      redpacket_pwd: "",
      redpacket_list: [],
      isActive: "",
    };
  },
  computed: {
    ...mapState(["user"]),
  },
  watch: {},
  created() {
    this.GetList();
  },
  mounted() {},
  methods: {
    openCdk() {
      if (!this.user.nickname) return this.$store.commit("setloginModal", true);

      if (!this.redpacket_pwd) {
        return this.$toast.error("请输入正确的口令");
      }

      api_ReceiveGiftCDK({ cdk: this.redpacket_pwd }).then((res) => {
        if (res.data.code === 0) {
          this.$toast.success(res.data.msg);
        } else {
          this.$toast.error(res.data.msg);
        }
      });
    },
    openNormal(item) {
      if (!this.user.nickname) return this.$store.commit("setloginModal", true);

      api_ReceiveGift({ id: item.id }).then((res) => {
        if (res.data.code === 0) {
          this.$toast.success(res.data.msg);
        } else {
          this.$toast.error(res.data.msg);
        }
      });
    },
    GetList() {
      api_GetGiftList().then((res) => {
        this.redpacket_list = res.data.data;
        console.log(" this.redpacket_list==", this.redpacket_list);
      });
    },
  },
};
